import { render, staticRenderFns } from "./OutForDelivery.vue?vue&type=template&id=082d2300&scoped=true&"
import script from "./OutForDelivery.vue?vue&type=script&lang=js&"
export * from "./OutForDelivery.vue?vue&type=script&lang=js&"
import style0 from "./OutForDelivery.vue?vue&type=style&index=0&id=082d2300&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082d2300",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VRow,VSpacer,VTextField})
